export enum RoutesNames {
  HOME = "/",
  ADRESS = "addresses",
  ACCOUNT_PAGE = "account",
  ACCOUNT_DETAILS = "details",
  ACCOUNT_FAVORITES = "favorites",
  ACCOUNT_DASHBOARD = "dashboard",
  ACCOUNT_ORDERS = "orders",
  ACCOUNT_REVIEWS = "reviews",
  CART = "cart",
  COLLECTION = "collection",
  COLLECTION_PAGE = "collection/:category",
  PRODUCT = "product",
  PRODUCT_PAGE = "product/:productId",
  SEARCH_RESULT_PAGE = "search/:searchTerm",
  REGISTER_PAGE = "register",
  SIGN_IN_PAGE = "sign-in",
}
